import { blue, green, neutral, red, yellow } from "./colors"

/**
 * @deprecated DO NOT USE. Use colors.ts instead.
 */
export const colors = {
  BG_DARK_GRAY_2: neutral[900],
  BG_DARK_GRAY: neutral[900],
  BG_GRAY: neutral[200],
  BG_LIGHT_GRAY_2: neutral[200],
  BG_LIGHT_GRAY_3: neutral[50],
  BG_LIGHT_GRAY_4: neutral[50],
  BG_LIGHT_GRAY: neutral[100],
  BORDER_GRAY: neutral[200],
  BUTTON_RED: red[500],
  DARK_SECONDARY: blue[400],
  NOTICE_TXT: yellow[800],
  PRIMARY: neutral[900],
  SECONDARY: blue[400],
  STANDARD_WHITE: neutral.white,
  STATUS_GREEN_BG_2: green[200],
  STATUS_GREEN_BG: green[300],
  STATUS_GREEN_TXT: green[800],
  STATUS_RED_BG_2: red[200],
  STATUS_RED_BG: red[300],
  STATUS_RED_TXT: red[800],
  TEXT_DARK_GRAY: neutral[600],
  TEXT_DARK: neutral[900],
  TEXT_LIGHT_GRAY_2: neutral[400],
  TEXT_LIGHT_GRAY: neutral[500],
  YELLOW: yellow[200],
}
